import { Navigate, useOutletContext } from "react-router-dom";
import Groomers from "../components/landing/Groomers";

export default function GroomersPage() {
  const content = useOutletContext();
  if (content.settings?.showGroomers === false) return <Navigate to="/" replace />;
  return <Groomers groomers={content.groomers} />;
}
